import { render } from "./shopping-index.vue?vue&type=template&id=6af17920"
import script from "./shopping-index.vue?vue&type=script&lang=js"
export * from "./shopping-index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__